export default __webpack_public_path__ + "static/media/67.66814665.jpg";